<template>
  <div>
    <h2 class="bordered-box-header">Umówione lekcje / rozmowy w ramach wybranego makrocyklu</h2>
    <b-container fluid class="bordered-box">
      <b-row class="justify-content-center" v-if="loading">
        <b-spinner big label="Loading..."></b-spinner>
      </b-row>
      <b-row v-else-if="cycle">
        <b-col cols="12" v-if="!cycle.events.length">
          <span v-if="!cycle.events.length" class="text-danger">Brak umówionych spotkań</span>
        </b-col>
        <b-col lg="6" v-else>
          <h3 class="mb-3">Spotkania pierwotne</h3>
          <b-row no-gutters class="mb-2">
            <b-col md="6" style="font-weight:600">Lekcji - {{lessonsCount}} / 4</b-col>
            <b-col md="6" style="font-weight:600">Rozmów - {{talksCount}} / 16</b-col>
          </b-row>
          <b-row
            v-for="event in mainEvents"
            :key="event.id"
            class="event-item"
            :class="{'selected-item': selectedEventId == event.id}"
            no-gutters
            @click="selectedEventId = event.id"
          >
            <b-col sm="6" md="5">
              <span class="label">{{event.date | datetime }}</span>
            </b-col>
            <b-col sm="6" md="4">
              <span class="label" :class="getTypeClass(event.type)">{{event.type | eventtype}}</span>
            </b-col>
            <b-col sm="6" offset-sm="6" offset-md="0" md="3">
              <span
                class="label"
                :class="getStatusClass(event.status)"
              >{{event.status | eventstatus }}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6" v-if="selectedEventId">
          <h3 class="mt-3">Spotkania na odrabianie zajęć</h3>
          <b-row v-if="!subEvents.length">
            <b-col cols="12">
              <span class="text-danger">Brak umówionych spotkań</span>
            </b-col>
          </b-row>
          <b-row
            v-else
            v-for="event in subEvents"
            :key="event.id"
            class="event-item no-pointer"
            no-gutters
          >
            <b-col sm="6">
              <span class="label">{{event.date | datetime }}</span>
            </b-col>
            <b-col sm="6">
              <span
                class="label"
                :class="getStatusClass(event.status)"
              >{{event.status | eventstatus }}</span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { axios, eventBus } from "@/_infrastructure";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      cycle: null,
      selectedEventId: null
    };
  },
  props: ["id"],

  mounted() {
    if (this.id) {
      this.refresh();
    }
  },
  computed: {
    mainEvents() {
      return this.cycle.events.filter(e => !e.parentId);
    },
    subEvents() {
      return this.cycle.events.filter(e => e.parentId == this.selectedEventId);
    },
    lessonsCount() {
      return this.cycle.events
        .filter(e => !e.parentId)
        .filter(e => e.type === 3).length;
    },
    talksCount() {
      return this.cycle.events
        .filter(e => !e.parentId)
        .filter(e => e.type === 2).length;
    }
  },
  methods: {
    refresh() {
      this.loading = true;

      axios
        .get("students/cycles/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          this.cycle = response.data;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    },
    getStatusClass(status) {
      return {
        ok: status === 0,
        noshow: status === 1,
        pending: status == null
      };
    },
    getTypeClass(type) {
      return {
        talk: type === 2,
        lesson: type === 3
      };
    }
  },
  filters: {
    datetime(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm") : "-";
    },
    eventstatus(value) {
      if (value === 0) return "OK";
      if (value === 1) return "No-show";
      return "Oczekujące";
    },
    eventtype(value) {
      if (value === 2) return "Rozmowa";
      if (value === 3) return "Lekcja";
      return "";
    }
  }
};
</script>
<style lang="scss" scoped>
.event-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: rgba(0, 0, 0, 0.03);
  border-radius: 1px;
  padding: 15px;
  margin-bottom: -1px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  &.no-pointer {
    cursor: default;

    &:hover {
      background: rgba(0, 0, 0, 0.03);
    }
  }
}
.lesson {
  color: green;
}
.talk {
  color: #666;
}
.label {
  font-weight: 600;
}
.noshow {
  color: red;
}
.ok {
  color: green;
}
.pending {
  color: #aaa;
}
.active-item {
  cursor: move;
}
.selected-item {
  background: rgba(0, 255, 0, 0.125);

  &:hover {
    background: rgba(0, 255, 0, 0.25);
  }
}
.label {
  font-weight: 600;
}
.value {
  font-style: italic;
  display: block;
  margin-bottom: 10px;
}
.add-item,
.edit-item,
.delete-item {
  margin: 0px 10px 10px 0px;
}

h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
